import { LazyQueryExecFunction, useLazyQuery } from '@apollo/client';

import {
  GET_DOCUMENT_EVENT_SIGNED_URL,
  GetAscSnapshotDocumentEventsQuery,
  GetDocumentEventSignedUrlQuery,
  GetDocumentEventSignedUrlQueryVariables,
} from '@neo.tax/shared';

export type AscSnapshotDocumentEvent = GetAscSnapshotDocumentEventsQuery['getAscSnapshotDocumentEvents'][number];

export type UseGetDocumentEventSignedUrl = {
  getDocumentEventSignedUrl: LazyQueryExecFunction<
    GetDocumentEventSignedUrlQuery,
    GetDocumentEventSignedUrlQueryVariables
  >;
  loading: boolean;
};

export const useGetDocumentEventSignedUrl = (): UseGetDocumentEventSignedUrl => {
  const [getDocumentEventSignedUrl, { loading }] = useLazyQuery<
    GetDocumentEventSignedUrlQuery,
    GetDocumentEventSignedUrlQueryVariables
  >(GET_DOCUMENT_EVENT_SIGNED_URL);

  return { getDocumentEventSignedUrl, loading };
};
